module.exports = __webpack_public_path__ + "assets/c9bb0a3b5bc50dabf4e3f7b18ea82188.mp3";